/** The `kit` area: the words the UI kit's primitives bring themselves
 *  (src/components/ui/). A caller's own label always wins over these. */
export const kit = {
  'kit.chipInput.placeholder': 'Add a value…',
  'kit.chipInput.describe': 'What does “{value}” mean? (optional)',
  'kit.chipInput.addDescription': 'Add a description',
  'kit.chipInput.remove': 'Remove {value}',
  'kit.chipInput.descriptionFor': 'Description for {value}',
  'kit.dialog.close': 'Close',
  'kit.helpTip.label': 'What is this?',
  'kit.menu.label': 'Menu',
  /** The row that leads a menu's drill-in back to the list it opened from. */
  'kit.menu.back': 'Back',
  'kit.multiSelect.none': 'None',
  'kit.select.placeholder': 'Select…',
  'kit.skeleton.loading': 'Loading',
  // The compact relative time: "now", then minutes, hours, days, weeks.
  'kit.relativeTime.now': 'now',
  'kit.relativeTime.minutes': '{count}m',
  'kit.relativeTime.hours': '{count}h',
  'kit.relativeTime.days': '{count}d',
  'kit.relativeTime.weeks': '{count}w',
  /** What a screen reader hears while dragging (src/components/ui/dnd-accessibility.ts). */
  'kit.dnd.instructions':
    'To pick up an entry, press space or enter. Move it with the arrow keys. Press space or enter again to drop it in its new place, or escape to cancel.',
  'kit.dnd.entry': 'an entry',
  'kit.dnd.pickedUp': 'Picked up {name}.',
  'kit.dnd.over': '{name} is over {target}.',
  'kit.dnd.moved': '{name} moved.',
  'kit.dnd.droppedOn': '{name} dropped on {target}.',
  'kit.dnd.dropped': '{name} dropped.',
  'kit.dnd.cancelled': 'Moving {name} was cancelled; it is back where it was.',
  // The prose editor (src/components/ui/prose-editor-body.tsx): the formatting
  // strip's buttons, the link popover, the two reference buttons and their
  // lists (src/components/ui/prose-references.tsx, docs/PROSE.md §5).
  'kit.proseEditor.strip': 'Formatting',
  'kit.proseEditor.bold': 'Bold',
  'kit.proseEditor.italic': 'Italic',
  'kit.proseEditor.strike': 'Strikethrough',
  'kit.proseEditor.code': 'Code',
  'kit.proseEditor.bulletList': 'Bullet list',
  'kit.proseEditor.numberedList': 'Numbered list',
  'kit.proseEditor.heading': 'Heading',
  'kit.proseEditor.quote': 'Quote',
  'kit.proseEditor.link': 'Link',
  'kit.proseEditor.person': 'Name a person',
  'kit.proseEditor.item': 'Name an item',
  /** The two lists, as a screen reader names them. */
  'kit.proseEditor.people': 'People',
  'kit.proseEditor.items': 'Items',
  /** The search field of a list on a phone. */
  'kit.proseEditor.findPerson': 'Find a person',
  'kit.proseEditor.findItem': 'Find an item',
  'kit.proseEditor.searching': 'Searching…',
  'kit.proseEditor.noPerson': 'No one matches.',
  'kit.proseEditor.noItem': 'No item matches.',
  /** The quiet note on a named person who cannot open the item: naming them
   *  tells them nothing (docs/PROSE.md §5.4). */
  'kit.proseEditor.cannotSee': 'Cannot see this item',
  'kit.proseEditor.linkAddress': 'Link address',
  'kit.proseEditor.linkPlaceholder': 'https://…',
  'kit.proseEditor.linkApply': 'Apply',
  'kit.proseEditor.linkRemove': 'Remove link',
  'kit.proseEditor.linkInvalid': 'Only a web address (http or https) can be a link.',
  /** A paste or a drop of an image or a file, refused until attachments
   *  exist (docs/PROSE.md §6, §7). */
  'kit.proseEditor.filesRefused': 'Images and files are not supported here yet.',
} as const;
